module.exports = __webpack_public_path__ + "img/day-8.295fec55.png";